module.exports = __webpack_public_path__ + "img/cc-images@2x.eb47e3b5.png";